import { useMemo } from "react";

import { useGetEngagementSegmentation } from "../../../api/insights";
import { ResponsesPieChart } from "../charts";
import SectionShell from "../SectionShell";

const GROUP_LABELS = {
  passive: "Passive",
  moderate: "Moderately engaged",
  highly: "Highly engaged",
};

function EngagementSegmentation({ eventId }) {
  const { data, isPending, isError, error } =
    useGetEngagementSegmentation(eventId);

  const chartData = useMemo(() => {
    const groups = data?.groups;
    if (!groups) return [];
    return ["passive", "moderate", "highly"].map((key) => ({
      name: GROUP_LABELS[key],
      value: Number(groups[key]?.count ?? 0),
    }));
  }, [data]);

  return (
    <SectionShell
      id="engagementSegmentation"
      title="Engagement segmentation"
      description="Attendees grouped by engagement level (passive, moderate, highly)."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="engagementSegmentation"
    >
      <ResponsesPieChart title="Engagement distribution" data={chartData} />
    </SectionShell>
  );
}

export default EngagementSegmentation;
